import { createSelector } from 'reselect';
import moment from 'moment';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';
import UserStore from '../../../../stores/UserStore';
import config from '../../../../config';

const reportFormatter = ReportComponent.formatter;
const reportUtils = ReportComponent.utils;

const today = (state) => state.dashboard.today.data;
const parameters = (state) => state.dashboard.today.parameters;
const last = (state) => state.dashboard.last.data;

export const mainSelector = createSelector(
    today,
    last,
    parameters,
    (todayData = [], lastData = [], parameters = {}) => {
        let dataDays = _getDataDays(todayData, lastData);
        const staticNames = UserStore.getTranslation().dashboard;
        const data = {
            'PublisherCreditTotalAmountConfirmed': {
                'title': reportUtils.getTitleChain('PublisherCreditTotalAmountConfirmed'),
                'subTitle': staticNames.subtitleIncome
            },
            'ActionNameRegCountConfirmed': {
                'title': reportUtils.getTitleChain('ActionNameRegCountConfirmed'),
                'subTitle': staticNames.subtitleRegs
            },
            'ActionTypeSaleCountConfirmed': {
                'title': reportUtils.getTitleChain('ActionTypeSaleCountConfirmed'),
                'subTitle': staticNames.subtitleSales
            },
            'Visits': {
                'title': reportUtils.getTitleChain('Visits'),
                'subTitle': staticNames.subtitleConversions
            }
        };

        for (let key in data) {
            const item = data[key];
            const valueToday = +dataDays.today[key] || 0;
            const valueYesterday = +dataDays.yesterday[key] || 0;
            let diff = 100;

            if (valueToday !== 0 && valueYesterday !== 0) {
                diff = Math.abs(((valueToday - valueYesterday) / valueYesterday) * 100);
            } else if (valueToday === 0 && valueYesterday === 0) {
                diff = 0;
            }

            item.today = reportFormatter.format(dataDays.fullToday[key] || 0, key, parameters);
            item.diffSing = Math.sign(valueToday - valueYesterday);
            item.diff = Math.round(diff) || 0;
        }

        return data;
    }
);

const _getDataDays = (data, lastData) => {
    let today = {};
    let fullToday = {};
    let yesterday = {};
    const formatToday = moment().format(config.reportDateFormat);
    const formatYesterday = moment().subtract(1, 'days').format(config.reportDateFormat);

    (data || []).forEach((dataDay) => {
        if (formatToday === dataDay.GroupBy) {
            today = dataDay;
        }
        if (formatYesterday === dataDay.GroupBy) {
            yesterday = dataDay;
        }
    });

    (lastData || []).forEach((dataDay) => {
        if (formatToday === dataDay.GroupBy) {
            fullToday = dataDay;
        }
    });

    return {
        today,
        fullToday,
        yesterday
    };
};
